import { Injectable } from '@angular/core';
import { LicenseService } from '../license.service';
import * as signalR from "@microsoft/signalr";
import { AppConfigService } from '../app-config.service';

@Injectable({
    providedIn: 'root'
})
export class LicenseHub 
{
    private hubConnection: signalR.HubConnection;

    constructor(private licenseService: LicenseService)
    {

    }

    public startConnection = () =>
    {
        if (this.hubConnection == null)
        {
            this.hubConnection = new signalR.HubConnectionBuilder()
                .withUrl(AppConfigService.appConfig.WebAPIServer + '/License')
                .withAutomaticReconnect()
                .build();

            // this.hubConnection.serverTimeoutInMilliseconds = 1000 * 60 * 10;
        }

        this.start();
        this.disconnected();
    }

    //SignalR Verbindung zum Server starten
    async  start()
    {
        if (this.hubConnection.state == signalR.HubConnectionState.Disconnected)
        {
            await this.hubConnection
                .start()
                .then()
                .catch(err =>
                {
                    setTimeout(() => this.start(), 5000);
                });
        }

    }
    public disconnected()
    {
        this.hubConnection.onclose(async () => {
            await this.start();
        });
    }

    public receiveLicense()
    {
        this.hubConnection.on('broadcastLicense', (license) =>
        {
            this.licenseService.setLicense(license);
          
        });
    }

}
